<template>
  <div flex="main:justify cross:center" class="navigator rfs12">
    <img
      src="https://static.wkanx.com/w002/M00/07/DE/CgIXlV9YSjCAW5SVAAAGXTEW0CM186.png"
      style="width: 1.03rem"
      class="csp"
      @click="go('home')"
    />
    <Menu />
  </div>
</template>
<script>
import Menu from './Menu';
export default {
  name: '',
  components: { Menu },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    go(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang='scss'>
</style>
